module.exports = __webpack_public_path__ + "static/img/sort-back1.0527fcb9.png";